import { FETCH_PRODUCTS, FETCH_ADDRESS_SUBSCRIPTION_PRODUCTS, FETCH_DOMICILIATION_PRODUCTS_ALL_ACCOUNTS } from './index'

export const fetchProducts = products => ({
  type: FETCH_PRODUCTS,
  products,
})

export const fetchAddressSubscriptionProducts = (addressId, products) => ({
  type: FETCH_ADDRESS_SUBSCRIPTION_PRODUCTS,
  addressId,
  products,
})

export const fetchDomiciliationProductsAllAccounts = (products) => ({
  type: FETCH_DOMICILIATION_PRODUCTS_ALL_ACCOUNTS,
  products,
})
